import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useState } from 'react';

interface Props {
  findTrip: (trip: number) => void;
}

export const PhotosFindTrip = ({findTrip}: Props) => {

  const [value, setValue] = useState('');


  return (
    <Input suffix={<SearchOutlined />} onChange={(e) => setValue(e.target.value)} onPressEnter={() => findTrip(parseInt(value))} value={value}/>
  )
}
